import React from "react";
import styles from "./IntroductionAlt.module.scss";
import FadeUp from "../effects/FadeUp";
import Row from "../layout/Row";
import Section from "../layout/Section";
import Container from "../layout/Container";

const IntroductionAlt = ({title, content, shortPaddingBottom, altColors, theme, productColor}) => {
    return title || content ? (
        <Section className={`${styles.introduction} ${shortPaddingBottom ? styles.introductionShortPaddingBottom : ""}`} theme={theme} productColor={productColor}>
            <Container>
                <Row>
                    <FadeUp className={styles.introduction__content}>
                        {title && <h3 className={`${styles.title} ${altColors ? styles.titleAltColor : ""}`}>{title}</h3>}
                        {content && <span dangerouslySetInnerHTML={{__html: content}} />}
                    </FadeUp>
                </Row>
            </Container>
        </Section>
    ) : null;
};

export default IntroductionAlt;